import { FileEdit, Calendar, Trash2, Edit, User } from 'lucide-react';
import { Card, CardContent } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { getWeekNumber } from './helpers';

export function DraftCard({ draft, areaLookup = {}, onOpen, onDelete }) {
  const areaDisplay = draft.selected_area
    ? (areaLookup[draft.selected_area] || draft.selected_area)
    : null;
  const userName = draft.user_name || draft.user_email || '';

  return (
    <Card className="shadow-sm hover:shadow-md transition-all border border-slate-200 rounded-xl overflow-hidden cursor-pointer" onClick={() => onOpen(draft)}>
      <CardContent className="p-0">
        {/* Top bar */}
        <div className="flex items-center justify-between px-5 py-3 bg-amber-50 border-b border-amber-100">
          <div className="flex items-center gap-3">
            <FileEdit className="w-5 h-5 text-amber-600" />
            <span className="text-sm font-semibold text-amber-700">Utkast</span>
            <span className="px-2 py-0.5 rounded-full text-[11px] font-medium bg-amber-100 text-amber-700 border border-amber-200">Uferdig</span>
          </div>
          <div className="flex items-center gap-2">
            <Button variant="outline" size="sm" className="h-8 text-xs" onClick={(e) => { e.stopPropagation(); onOpen(draft); }}>
              <Edit className="w-3.5 h-3.5 mr-1" /> Fortsett
            </Button>
            <Button variant="ghost" size="sm" className="h-8 w-8 p-0 text-slate-400 hover:text-red-500 hover:bg-red-50"
              onClick={(e) => { e.stopPropagation(); onDelete(draft.id); }}>
              <Trash2 className="w-3.5 h-3.5" />
            </Button>
          </div>
        </div>
        
        {/* Content */}
        <div className="px-5 py-4">
          <div className="flex flex-wrap items-center gap-x-4 gap-y-1 text-sm text-slate-600">
            <span className="flex items-center gap-1.5 font-medium text-slate-900">
              <Calendar className="w-4 h-4 text-slate-400" />
              {draft.sample_date ? new Date(draft.sample_date).toLocaleDateString('nb-NO', { day: 'numeric', month: 'short', year: 'numeric' }) : 'Dato ikkje sett'}
            </span>
            {draft.sample_date && (
              <span className="px-2 py-0.5 bg-slate-100 text-slate-600 rounded text-xs font-medium">
                Uke {getWeekNumber(draft.sample_date)}
              </span>
            )}
            {areaDisplay && (
              <>
                <span className="text-slate-400">&middot;</span>
                <span>{areaDisplay}</span>
              </>
            )}
            {userName && (
              <>
                <span className="text-slate-400">&middot;</span>
                <span className="flex items-center gap-1 text-xs text-slate-500">
                  <User className="w-3 h-3" /> {userName}
                </span>
              </>
            )}
            <span className="text-slate-400">&middot;</span>
            <span className="text-xs text-slate-400">
              Sist oppdatert: {draft.updated_at ? new Date(draft.updated_at).toLocaleString('nb-NO', { day: 'numeric', month: 'short', hour: '2-digit', minute: '2-digit' }) : '–'}
            </span>
          </div>
        </div>
      </CardContent>
    </Card>
  );
}
